module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer000"
    }
  }, [_c('p', {
    staticClass: "Praise-Heading",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Praise for")]), _vm._v(" "), _c('p', {
    staticClass: "SL",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Southern Lights")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("This cookbook is just irresistible! The recipes are yummy, the pictures are fun, and the recipe titles are beckoning. It’s a charming book.")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Citation",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—Nathalie Dupree, James Beard Award–winning cookbook author, chef, and cooking show host ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Lauren McDuffie’s "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("Southern Lights")]), _vm._v(" gives us a Southern cuisine for the twenty-first century. Her recipes are lighter, tastier, and simpler to execute, while still brimming with Southern soul.")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Citation",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—Matt and Ted Lee, authors of "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("The Lee Bros. Charleston Kitchen")])]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Move over butter, pork, sour cream, and sugar, there’s a new Southern cuisine in town! Written from a healthy perspective, but with the Southern home cook in mind, "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("Southern Lights")]), _vm._v(" presents innovative flavor pairings that bring new life to old standards. Lauren’s bold interpretation may challenge the traditional mold, but will inspire your next health-conscious meal.")]), _vm._v(" "), _c('p', {
    staticClass: "Praise-Citation",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("—Belinda Smith-Sullivan, chef, author, food writer, spice blends entrepreneur, and pilot")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer001"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Photo of peaches.",
      "src": "image/Atmopsheric.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer002"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "Photo of title page.",
      "src": "image/page3.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer003"
    }
  }, [_c('p', {
    staticClass: "Dedication",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("For Elle and Easton, little lights of mine.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Digital Edition 1.0")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Text © 2023 Lauren McDuffie")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Illustrations © 2023 Tiffany Mitchell")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Photographs © 2023 Lauren McDuffie")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("All rights reserved. No part of this book may be reproduced by any means whatsoever without written permission from the publisher, except brief portions quoted for purpose of review.")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Published by")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Gibbs Smith")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("P.O. Box 667")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Layton, Utah 84041")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("1.800.835.4993 orders")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.gibbs-smith.com",
      "target": "_blank"
    }
  }, [_vm._v("www.gibbs-smith.com")])]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Library of Congress Cataloging-in-Publication Data ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Names: McDuffie, Lauren, author. | Mitchell, Tiffany, illustrator.   ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Title: Southern lights : easier, lighter, and better-for-you recipes from the South / recipes and photographs by Lauren McDuffie ; illustrations by Tiffany Mitchell.   ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Identifiers: LCCN 2022046881 | ISBN 9781423661474 (hardback) | ISBN 9781423661481 (ebook)   ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Subjects: LCSH: Cooking, American--Southern style. | BISAC: COOKING /  ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("   Regional & Ethnic / American / Southern States | COOKING / Health & Healing / General | LCGFT: Cookbooks.  ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Classification: LCC TX715.2.S68 M3332 2023 | DDC  ")]), _vm._v(" "), _c('p', {
    staticClass: "CIP",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("   641.5975--dc23/eng/20221007  ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer004"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "Illustration of vegetables.",
      "src": "image/page5.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "_idContainer005"
    }
  }, [_c('p', {
    staticClass: "contents",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors#_idTextAnchor000"
    }
  }, [_vm._v("Preface ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors#_idTextAnchor001"
    }
  }, [_vm._v("Here’s the Thing About Southern Food . . .  ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors#_idTextAnchor002"
    }
  }, [_vm._v("How This Book Works")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors#_idTextAnchor003"
    }
  }, [_vm._v("Southern Exchange")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors#_idTextAnchor004"
    }
  }, [_vm._v("Last Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor005"
    }
  }, [_vm._v("Fridge Door Things")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor006"
    }
  }, [_vm._v("Southern Summer Concentrate")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor007"
    }
  }, [_vm._v("Herby, Lemony Yogurt ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor008"
    }
  }, [_vm._v("Yogurty Whipped Cream")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor009"
    }
  }, [_vm._v("Comeback Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor010"
    }
  }, [_vm._v("Tahini, Cardamom, and Date Caramel ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor012"
    }
  }, [_vm._v("Caramelized Onion and Pimiento Slather")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor014"
    }
  }, [_vm._v("Scorned-Women Hot Sauce ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor015"
    }
  }, [_vm._v("BBQ Spice Blend")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor016"
    }
  }, [_vm._v("My Favorite BBQ Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor017"
    }
  }, [_vm._v("Rainbow Brights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor018"
    }
  }, [_vm._v("House Dressing")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor019"
    }
  }, [_vm._v("Salty Butter–Whipped Honey")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor020"
    }
  }, [_vm._v("Citrusy Poppy Seed Coleslaw")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor021"
    }
  }, [_vm._v("First Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor022"
    }
  }, [_vm._v("Vanilla Cream–Stuffed Baked Beignets ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor023"
    }
  }, [_vm._v("Herby Potato and Salmon Hash")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor024"
    }
  }, [_vm._v("Crunchy Cinnamon Toast ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor025"
    }
  }, [_vm._v("Smoky Pinto Beans with Vinegared Tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor026"
    }
  }, [_vm._v("Eggs Sardou, Sort Of")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor027"
    }
  }, [_vm._v("Peachy Pecan Pie Pancake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor028"
    }
  }, [_vm._v("Spiced Pork Tenderloin with Apples and Onion")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor029"
    }
  }, [_vm._v("Crunchy Coconut-Pineapple “Doughnuts”")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor030"
    }
  }, [_vm._v("Any Beans and Greens Breakfast Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor031"
    }
  }, [_vm._v("Porridge Three Ways")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor032"
    }
  }, [_vm._v("Maple-Molasses Grits with Salty, Slumped Fruit")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor033"
    }
  }, [_vm._v("Peanut Butter–Oatmeal Breakfast Cookies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC3",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors2#_idTextAnchor034"
    }
  }, [_vm._v("Savory Cheddar Waffled Oatmeal ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor035"
    }
  }, [_vm._v("Sea Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor036"
    }
  }, [_vm._v("Pan-Seared Oysters in a Buttermilk Remoulade Bath  ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor037"
    }
  }, [_vm._v("Viet-Cajun Seafood Broil with Chili-Garlic Oil")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor038"
    }
  }, [_vm._v("Crispy Scallops with Tomatoey Mignonette Vinaigrette ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor039"
    }
  }, [_vm._v("Hush Puppy Popovers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor040"
    }
  }, [_vm._v("Roasted Shrimp with Sweet Peas, Zucchini, and Oil-Toasted Pistachios")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor041"
    }
  }, [_vm._v("Seafood Stew with Toasted Garlic Broth")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor042"
    }
  }, [_vm._v("Sandbar Steamer")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor043"
    }
  }, [_vm._v("Tuna Salad with Roasted Lemon, Crunchy Potatoes, and Green Beans")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor044"
    }
  }, [_vm._v("Southern Pickled Shrimp")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor045"
    }
  }, [_vm._v("Mussels and Turnip Greens in Pickled Pepper Broth")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor046"
    }
  }, [_vm._v("Day Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor047"
    }
  }, [_vm._v("Crispy Coleslaw Pancake ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor048"
    }
  }, [_vm._v("Sticky, Crispy Tofu with Maple Molasses Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor049"
    }
  }, [_vm._v("Energizing Pecan Pie Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor050"
    }
  }, [_vm._v("Velvety Red Pepper and Tomato Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor051"
    }
  }, [_vm._v("Jammy Mignonette-Marinated Eggs ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor052"
    }
  }, [_vm._v("Butter-Bean Succotash")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor053"
    }
  }, [_vm._v("Frosted Mocha")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor054"
    }
  }, [_vm._v("Peaches with Basil-Whipped Cottage Cheese and Hot Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor055"
    }
  }, [_vm._v("Tea Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor056"
    }
  }, [_vm._v("Apple Tea Rose Tarts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor057"
    }
  }, [_vm._v("Honeyed Vanilla-Watermelon Tea")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor058"
    }
  }, [_vm._v("Secret Garden Ice")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor059"
    }
  }, [_vm._v("Jalapeño Popper Quiche Bites")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor060"
    }
  }, [_vm._v("Smoked Salmon and Cucumber Tea Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor061"
    }
  }, [_vm._v("Cobbled Stone Fruit and Melon Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor062"
    }
  }, [_vm._v("Black Tea and Bay–Braised Alliums on Toast ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor063"
    }
  }, [_vm._v("Butter Bean, Butternut, and Buttermilk Salad in Butter Lettuce ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor064"
    }
  }, [_vm._v("Honey and Lemon–Soaked Teacup Cakes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors5#_idTextAnchor065"
    }
  }, [_vm._v("Not Your Mama’s Ambrosia")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor066"
    }
  }, [_vm._v("Break Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor067"
    }
  }, [_vm._v("Salty, Seedy Crackers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor068"
    }
  }, [_vm._v("Figs in a Blanket")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor069"
    }
  }, [_vm._v("Red Velvet Pecans")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor070"
    }
  }, [_vm._v("Crushed Corn Veggie Dip")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor071"
    }
  }, [_vm._v("Chicken-Fried Popcorn ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor072"
    }
  }, [_vm._v("Benedictine-ish")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor073"
    }
  }, [_vm._v("Grits and Honey Granola Bars")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor074"
    }
  }, [_vm._v("Parmesan Baked Pickles with Remoulade Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor075"
    }
  }, [_vm._v("Pimiento Cheese Hummus")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor076"
    }
  }, [_vm._v("Crunchy Black-Eyed Peas ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor077"
    }
  }, [_vm._v("Green Lights ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor078"
    }
  }, [_vm._v("Chili-Soaked Watermelon with Smoked Almonds ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor079"
    }
  }, [_vm._v("Thunder and Lightning")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor080"
    }
  }, [_vm._v("Three Green Tomatoes")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor081"
    }
  }, [_vm._v("Honey-Roasted Radishes with Herby, Lemony Yogurt ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor083"
    }
  }, [_vm._v("Raw and Roasted Grapes with Shaved Carrots and Blue Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor084"
    }
  }, [_vm._v("Warm Broccoli and White Bean Spoon Salad ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor085"
    }
  }, [_vm._v("Copper Pennies")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor086"
    }
  }, [_vm._v("Green Beans and Fennel With Beet Hummus and Lemony Walnuts")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor087"
    }
  }, [_vm._v("Southern Killed Lettuces")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors7#_idTextAnchor088"
    }
  }, [_vm._v("Warm, Garlicky Beans with Shaved Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor089"
    }
  }, [_vm._v("Fire Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor090"
    }
  }, [_vm._v("“Pulled” BBQ Spaghetti-Squash Sandwiches")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor091"
    }
  }, [_vm._v("Dry-Rubbed Greens with Crispy Kale Chips")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor092"
    }
  }, [_vm._v("Brown Sugar and Chile–Crusted Baked Chicken Wings with Buttermilk-Chive Dipping Sauce")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor093"
    }
  }, [_vm._v("Chicken Sausage, Apple, and Red Cabbage Bake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor094"
    }
  }, [_vm._v("Broiled Flank Steak with Plums and Chili-Garlic Oil ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor095"
    }
  }, [_vm._v("Blackened Cauliflower Steaks with Garlicky Scallions")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor096"
    }
  }, [_vm._v("Honey-Caramelized Tomato Upside-Down Cornbread ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor097"
    }
  }, [_vm._v("Lace Hoecakes ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors8#_idTextAnchor098"
    }
  }, [_vm._v("Baked-Bean Mac and Cheese")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor099"
    }
  }, [_vm._v("Night Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor100"
    }
  }, [_vm._v("Frico Chicken in a Garlicky Buttermilk Bath")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor101"
    }
  }, [_vm._v("Creamy Chicken Meatball Country Captain ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor102"
    }
  }, [_vm._v("Baking Sheet Catfish with Okra, Corn, and Tomatoes ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor103"
    }
  }, [_vm._v("Green Chili Pork with Grits Dumplings ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor104"
    }
  }, [_vm._v("Chicken Fricassee ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor105"
    }
  }, [_vm._v(" Balsamic Pear and Shallot Smothered Pork Chops")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor106"
    }
  }, [_vm._v("Brunswick Stew No. 3")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor107"
    }
  }, [_vm._v("Spinach and Artichoke Pot Pie with Turkey Sausage")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor108"
    }
  }, [_vm._v("Jezebel Chicken")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor109"
    }
  }, [_vm._v("Holiday Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor110"
    }
  }, [_vm._v("Pomegranate and Mandarin Relish")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor112"
    }
  }, [_vm._v("Creamy Roasted Garlic Mashed Potatoes ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor113"
    }
  }, [_vm._v("Roasted Brussels Sprouts with Vanilla-Cayenne Glaze")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor114"
    }
  }, [_vm._v("Quick Chicken and Apple Stuffing Skillet ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor115"
    }
  }, [_vm._v("Fancy Winter Fruit Salad")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor116"
    }
  }, [_vm._v("Two-Ingredient Squash and Caramelized Onion Soup")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor117"
    }
  }, [_vm._v("Warm Radicchio and Squash Salad with Brown-Buttered Dates")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor118"
    }
  }, [_vm._v("Milky Oven-Braised Carrots ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor119"
    }
  }, [_vm._v("A Green Bean Un-Casserole for Mushroom Lovers")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor120"
    }
  }, [_vm._v("Caramelized Sweet Potatoes with Vanilla Cream and Hot Honey")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor121"
    }
  }, [_vm._v("The Joys of a Simple Roasted Vegetable Platter ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor122"
    }
  }, [_vm._v("Sweet Lights")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor123"
    }
  }, [_vm._v("Jammy Kiwi-Berry Pandowdy ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor124"
    }
  }, [_vm._v("Apples with Smoked Almonds and Tahini, Cardamom, and Date Caramel")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor125"
    }
  }, [_vm._v("Boozy Bananas Foster Bread Pudding ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor126"
    }
  }, [_vm._v("Ruffled Buttermilk (Punch) Pie")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor127"
    }
  }, [_vm._v("Peanut Butter–Sesame Cookie Brittle")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor128"
    }
  }, [_vm._v("Vegan Preacher Cookies ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor129"
    }
  }, [_vm._v("Snow Cream for Southerners")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor130"
    }
  }, [_vm._v("Bursting-Berry Company Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor131"
    }
  }, [_vm._v("The Healthy Southern Soda Fountain")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor132"
    }
  }, [_vm._v("Epilogue")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor133"
    }
  }, [_vm._v("An Enlightened Buttermilk Biscuit ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor134"
    }
  }, [_vm._v("Acknowledgments ")])]), _vm._v(" "), _c('p', {
    staticClass: "TOC2",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor135"
    }
  }, [_vm._v("Metric Conversion Chart")])])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer006"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "Photo of fruits and line drawings.",
      "src": "image/page8.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer007"
    }
  }, [_c('p', {
    staticClass: "Heading---Talky-Text-Sections",
    attrs: {
      "id": "_idParaDest-1",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Preface ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-First-Opener _idGenCharOverride-2"
  }, [_vm._v("I think it’s worth acknowledging,")]), _vm._v(" right here at the start of things, that this isn’t a book about me. Not really. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("From the first page to the last, the entire goal here is to help you go about your days as deliciously as possible while not sacrificing your good health and overall wellness in the process. Or, I suppose we could flip that, and say this book is meant to help you maintain your good health while not sacrificing a bit of deliciousness. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Either way, it is—primarily and above all else—about you. But even so, I do need to talk about myself for just a minute, to provide you with the proper context for it all. "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("Who even is this person? Why does she call for so much yogurt in her recipes? What does it all mean?")])]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Admittedly, I have a flair for the dramatic and am prone to verbosity, but I will try to make this short, sweet, and (hopefully) worth your time. I also have a hard-to-shake propensity for punning, and I thank you in advance for your patience with it all. It cannot be helped. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("Get to the recipes already!")])]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Y’all—I get it, I really do (that was a food-blogging joke, by the way). I’m excited to get to the recipes myself, but if you’ll indulge me for just a moment, I’m going to go about introducing them a little bit . . . "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("setting the stage")]), _vm._v(". This is primarily so you’ll get a good sense of things, a solid understanding of what it is you are about to read and cook. Just as a movie is drastically more compelling when you know that it is based on a true story, so too is a recipe. Is the backstory going to make the food taste better? Doubtful. But I do believe that understanding the context in which this book lives could very well make it more fun for you to use, maybe more interesting, and hopefully more meaningful. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("It is a remarkable feeling to know that strangers are reading your words and absorbing your ideas. But that remarkability evolves into a sort of responsibility when you’re asking for not only their time but also their money (ingredients), spaces (kitchens), physical effort (cooking), and occasions. Since I hope to infuse your dinners, lunches, breakfasts, holidays, and all of the occasions in between with these wholesome, Southern-inspired recipes, I have a responsibility to stretch the book at its seams just a little bit, past the recipes themselves, to show you the bigger picture. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("My work as a recipe developer and food blogger has provided me the distinct advantage of having this long-running, open-ended dialogue with other home cooks, the people for whom all my work is intended in the first place. As I write and send my recipes out into the world, they are fine-tuned and bettered by the home cooks who give them life in their own kitchens. It’s an amazingly educational symbiosis of sorts, this process of working with and for other home cooks, learning what people want and what they don’t really dig as much. This has absolutely informed the food you’ll see here. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The recipes inside the pages of this book are like living, breathing things that are caught—for now—between two covers. They all have their befores, their unique histories, migrations, and meanderings: their reasons for being. I certainly didn’t invent the concepts of cornbread, or savory oatmeal, or snow cream. These are simply things that I love, for one reason or another, and they fit perfectly here. By welcoming them into your kitchen, you, reader, give them new life, releasing them back into the wild . . . continuing and enriching their stories. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And so it goes. From one home cook to another, thanks for that. It’s the very best part of it all. ")]), _vm._v(" "), _c('p', {
    staticClass: "Heading---Talky-Text-Sections",
    attrs: {
      "id": "_idParaDest-2",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("Here’s the Thing About Southern Food . . .  ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-First-Opener _idGenCharOverride-2"
  }, [_vm._v("Southern cooking has quite the reputation,")]), _vm._v(" doesn’t it? "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("Heavy! Greasy! Unhealthy!")]), _vm._v(" When people heard that I was working on a healthy Southern cookbook, the responses were largely as follows: "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("Oh, bless her heart. Healthy Southern cooking—that’s an oxymoron. There’s no such thing!")])]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Well, with this book, I beg to differ. The scope of the popular narrative surrounding Southern food is, by and large, pretty narrow. It is a cuisine that is well known for its heft and indulgence, its deep-fried items, and its butter-laden fare, particularly outside of the region. While there is obvious validity to this, it’s just not the whole story—not even close. As a home cook who has done the majority of her culinary learning in the South, from the foothills of central Appalachia to the sandy, abundant Low Country coastline, I know the whole truth. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We’re going to explore and celebrate the broader spectrum of Southern cooking here—both the iconic classics and some lesser-known gems. Though so much of everyday Southern cooking is actually wholesome, incredibly simple, and healthy by all accounts (it’s true!), there are still plenty of recipes and occasions where the food adorning a Southern table can be pretty heavy. For many Americans, their exposure to Southern cooking doesn’t go much past the popular mainstays (the fried chicken, the biscuits and gravy, the smothered pork chops, etc.). This over-the-top heaviness gives Southern food a sort of infamous charm, and we’ll definitely be lightening up some of these classics.")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Throughout these pages, I’m going to (politely) refute the claim that Southern food is all bad for you and hopefully breathe new life into some tired, worn-out notions. Once you make your way through the stereotypes, past the overwrought, done-to-death, attention-seeking heavy hitters, the archives of Southern cookery shine with a special sort of brilliance. The great respect paid to all of the goodness that is grown in Southern ground can be felt in so many classic but lesser-known recipes, techniques, and traditions. This truth stands as the guiding force behind much of the recipe selection in this book, as it is very garden driven. We’ll shed some light on the quieter chapters of Southern cooking—the healthy, lighter side of the Southern table. It’s there, I promise. And it’s remarkable, actually. There’s a magic to it.")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The heart of Southern cooking beats for fresh seasonal produce. There is such great respect for fruits and vegetables, prepared thoughtfully and with no heaviness whatsoever. Much of the Southern diet actually resembles that of the Mediterranean, considered the healthiest in the world. By highlighting some of these truths in simple, straightforward presentations, this book will dismantle the pop-mythologies that brand Southern food as entirely unhealthy, all heavy and guilt-ridden. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Because, you see, that is simply not the case.")]), _vm._v(" "), _c('p', {
    staticClass: "Heading---Talky-Text-Sections",
    attrs: {
      "id": "_idParaDest-3",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor002"
    }
  }), _vm._v("How This Book Works")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-First-Opener _idGenCharOverride-2"
  }, [_vm._v("This is not a diet book.")]), _vm._v(" It’s not about losing anything or subtracting this and that. I suppose if we wanted to, we could play a game of recipe limbo. "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("How low can we really go? ")]), _vm._v("We could whittle these dishes down to mere shadows of their former selves, all for the goal of winning the numbers game. Something like “Name That Tune: Recipe Edition.” "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("I can make a casserole in 300 calories or less, Bob!")])]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" Sure, we could do that. But here’s one thing I know for certain: You can serve people the lightest, most low-cal, fat-free food on the planet, but no one’s going to eat it if it doesn’t taste good. Furthermore, just because something’s fat-free or low in calories doesn’t mean it’s good for you. I’m far more interested in what my food and ingredients do "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("for")]), _vm._v(" me than what they don’t. So we’ll politely kick the scarcity mindset to the curb and embrace one of abundance. More is so often more. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The bones of any recipe are made up of ingredients. The magical sorcery otherwise known as everyday home cooking carries us to an infinite number of delicious destinations, depending on the ingredients we select and how we choose to wield them. By picking our ingredients with greater intention and attention, we’ll open up a vibrant world of Southern cooking that fully embraces the deep reverence for all of the goodness that is grown in, on top of, and all around the Southern ground. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" For the chapters in this book, the notions of health and wellness are guiding lights. From breakfast and lunch to snacks, tea time, and even holidays, this is a decidedly lighter look at the Southern table in its many varied forms. But the crucial companions of taste and flavor are along for the ride as well. These recipes aren’t necessarily trying to lure you down the most well-beaten paths of Southern cookery, nor are they attempting to coax you down any roads less traveled. Really, I’d say we’re aiming for somewhere in the middle. These are lighter, better-for-you foods built on familiar foundations. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v(" By setting classically heavy recipes to a decidedly more healthful tune and showing off some Southern fare that is light to begin with, I hope to give you ways to enjoy your favorite Southern dishes more often (abundance mindset, remember?). We’ll also discover new ways to incorporate classic Southern ingredients and techniques into your cooking repertoire as well (I’m looking at you, pickles). From watermelon, butter beans, and dark leafy greens to buttermilk, honey, and thick, gooey molasses—these pages are bursting with some seriously delicious Southern powerhouses, a true all-star lineup. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I’m not a nutritionist, nor am I a trained dietitian, schooled in the science of food and its nuanced effects on our bodies. But what I am is a cook with a good amount of kitchen common sense—and I bet you’ve got it, too. Most of us are aware of the basic facts that eating a lot of sugar is not ideal nor is the frequent consumption of deep-fried fare or cooking with calorie-dense saturated fats. These aren’t secrets; they’re not profound revelations. We all know better. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So the trick, I think, is knowing what to do with this common sense of ours. Rather than ignoring it and making regretful, guilt-ridden decisions, let’s invite common sense to the table. I’ve got more than a hundred recipes here for you that aim to do just that. This book is filled with big-little ideas and inspiration that are intended to help you (and me) take this common kitchen sense and run with it in the direction of our good health and overall wellness. And run we will, y’all, to some pretty delicious places, if I do say so myself. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer008"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-3",
    attrs: {
      "alt": "Photo of food\n.",
      "src": "image/Cover_Option_P.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "Heading---Talky-Text-Sections",
    attrs: {
      "id": "_idParaDest-4",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor003"
    }
  }), _vm._v("Southern Exchange")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-First-Opener _idGenCharOverride-2"
  }, [_vm._v("The primary way I went about lightening up Southern dishes ")]), _vm._v("was to simply take a good, hard look at what’s in my kitchen—and why. "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("What fats do I cook with most often, and are there better ones out there that I should be using? Are there leaner cuts of meat that would work just as well in my favorite recipes? Do I really need to be using mayo every single day?")])]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Looking through a lighter lens, I came up with improvements to my larder (no one I know actually uses this word, but man, I love it). I exchanged some heavier, unhealthy ingredients for more wholesome, lighter ones—things that work with and for my body rather than against it. When I was finished, my kitchen landscape looked so much cleaner, lighter, and more healthful. Furthermore, not a bit of flavor was lost in these efforts. Cool.  ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "Another-Heading---Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Swap Meat")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There is certainly a time and place for fatty, rich, succulent cuts of meat. Absolutely. Bacon; sausage; brisket; pork shoulder; skin-on, dark-meat chicken; ribs and rib-eyes. It’s all delicious, but not necessarily the type of food we should be consuming all of the time. As such, this book contains lighter, leaner swaps for the aforementioned proteins. We’ll just put them to work in different, more thoughtful ways to ensure we get the best flavors and textures possible.")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("We’ll reach for chicken sausage instead of beef or pork. Leaner slices of prosciutto or salty country ham will replace bacon. Juicy, flavorful pork tenderloin will be seasoned just like breakfast sausage, and in one particularly cheeky instance, we’ll “pull” strands of tangled spaghetti squash through a homemade BBQ sauce, mimicking the briar patch of fatty pork that is often smashed between two buns. ")]), _vm._v(" "), _c('p', {
    staticClass: "Another-Heading---Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Dairy Bar")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("There may be no single ingredient more widely associated with Southern cooking than butter. It’s like a miracle food, and I love it "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("beyond")]), _vm._v("—can you even imagine life without it? I certainly cannot. Same goes for silky full-fat whipping cream, sour cream, cream cheese, and any/all manner of hard and soft cheeses. These things are great. And maybe the best way to preserve and highlight their greatness is to maintain their rarity. If we indulge in them daily, they lose their shine—it’s no longer a treat or an indulgence if we do it all the time. I like to treat these cherished, creamy items almost like “special occasion” ingredients. I haven’t rid my diet of them entirely; I just don’t make a habit of cooking with them every day. They are “sometimes” things.")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("And so, I’ll see your heavy cream and butter and raise you coconut cream and buttermilk. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The items below are "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("all-the-time things")]), _vm._v(" because they’re lighter and more nutritious—they serve us better. As such, they pop up a lot throughout this book’s pages. Like, a whole lot.")]), _vm._v(" "), _c('p', {
    staticClass: "List-Paragraph",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Buttermilk")]), _vm._v(" "), _c('p', {
    staticClass: "List-Paragraph",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Coconut milk and coconut cream")]), _vm._v(" "), _c('p', {
    staticClass: "List-Paragraph",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Cottage cheese ")]), _vm._v(" "), _c('p', {
    staticClass: "List-Paragraph",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Milk")]), _vm._v(" "), _c('p', {
    staticClass: "List-Paragraph",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Plain Greek yogurt")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer010"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-4",
    attrs: {
      "alt": "Illustration of split coconut.",
      "src": "image/page15.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer011"
    }
  }, [_c('p', {
    staticClass: "Another-Heading---Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Sugar, Sugar")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Again, this book is all about "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("dialing back")]), _vm._v(" on the ingredients that might not serve us best—lightening things up a bit—it’s not about turning the volume all the way down. We’ll still enjoy sugar, just in different ways and in various forms. We’ll use natural, unrefined/less-refined sweeteners like pure maple syrup, honey, coconut sugar, and dates. We’ll also watch the portions we use as well, as that is really what it all boils down to, so to speak. While unrefined sugars retain a bit more trace nutrients than the refined stuff, the best rule of thumb is to aim for a reduced intake of sugars all around. So many of the sweets in this book are decidedly less sweet. Which, incidentally, is exactly how I like them. So a win-win there. ")]), _vm._v(" "), _c('p', {
    staticClass: "Another-Heading---Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Well-Oiled")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I could drink olive oil, I really could. In fact, I have. I’ve done that. It’s liquid gold to me, and this book is dripping with it. Sure, there’s fat in it—it is an oil, after all. But it’s the kind of fat that will go to work for you in such beneficial ways. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("So yes, I call for it a lot throughout this book, and most often in its regular state (i.e., "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("not extra virgin")]), _vm._v("). People go tit for tat over these things, but for me, it mostly comes down to cost. Extra virgin is pricier, typically, so I like to save it for applications in which it is used more sparingly and its amazing flavor isn’t lost—things like finishing raw sauces and salsas, drizzling over finished dishes, and rounding out a great salad dressing. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Unlike some other fats, olive oil has not been linked to weight gain, heart disease, or chronic illness. It is rich in antioxidants and monounsaturated fatty acids and has proven benefits to the heart, brain, joints, and beyond. Plus? It’s really delicious. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("I call for other cooking fats occasionally, but olive oil is by far the most-used cooking fat in this book, so it absolutely deserves its own preamble here. ")]), _vm._v(" "), _c('p', {
    staticClass: "Heading---Talky-Text-Sections",
    attrs: {
      "id": "_idParaDest-5",
      "lang": "en-US"
    }
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor004"
    }
  }), _vm._v("Last Lights")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-First-Opener _idGenCharOverride-2"
  }, [_vm._v("Many cookbooks have a section like this,")]), _vm._v(" one where a list of good-to-have kitchen staples is laid out—the last notes and finishing touches that make a dish sing. I always enjoy them because it’s like getting a peek inside another cook’s kitchen. You learn what’s important to them, what they get especially excited about. I’ve got my own list of worthy pantry essentials for you here, but this one is pared down and tailored specifically to the matter at hand: lighter, better-for-you cooking.")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("Picture this: You’ve taken care to prepare a recipe from start to finish and are ready to dig in. You stop to sample your dish and discover that it’s just not quite right—something’s missing. This is perfectly normal and doesn’t necessarily mean that there is anything wrong with the recipe or your execution of it. It just means that it isn’t complete yet—it’s missing a last, finishing touch.")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_vm._v("The proper remedies for lackluster food are usually not "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("more sugar or more butter!")]), _vm._v(" Rather, they are so often "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("more acid")]), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v(", more salt, or more crunch!")]), _vm._v(" Like a superhero’s tool belt or a magician’s bag of tricks (pick a metaphor, any metaphor), each item listed here is something I reach for to give my food that extra je nais se quoi (or “wang,” as my grandma would’ve said). These things fill in the flavor gaps in a big way: They complete the scene—without weighing anything down. Like delicious whispered secrets from me to you, this is my essential list of flavorful, finishing touches.  ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Buttermilk ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _vm._v(" Another creamy ingredient you’ll spot throughout this book is buttermilk. Despite what the name might have you believe, buttermilk doesn’t contain any butter whatsoever and is actually a fermented and cultured milk product that contains beneficial bacteria and nutrients. Its distinctly sour taste helps achieve deeper, balanced flavors in so many things, from a "), _c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors4#_idTextAnchor047"
    }
  }, [_vm._v("Crispy Coleslaw Pancake")]), _vm._v(" to a "), _c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors11#_idTextAnchor130"
    }
  }, [_vm._v("Bursting-Berry Company Cake")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Flaky sea salt ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }), _vm._v("James Beard so famously posed the question, “Where would we be without salt?” Salt is, by far, the ingredient of greatest power and influence in my kitchen. It’s the boss. Without it, so many recipes would live in bland, boring states of tragically wasted potential. To build flavor and to achieve adequate seasoning, I keep a small pinch pot of flaky sea salt at the ready, and I use it to finish almost everything that hits my table, from roasted chicken to crispy potatoes. It can take a recipe from mediocre to mouthwatering in a hurry. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Fresh herbs ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }), _vm._v("There is no shortage of bright green herbs throughout the photos in this book. This isn’t just for appearances (though green is my favorite color); it reflects a genuine everyday trick of mine. There are few meals that don’t get a shower of verdant, fresh herbs before hitting my table, as it is an amazing way to achieve a burst of freshness, nutrition (hello, watercress), and massive flavor (talking to you now, arugula). Even my desserts often get a bit of chopped mint or basil for the same reasons. Keeping a small-yet-mighty selection of green herbs in the fridge is a great way to finish recipes and bring them to life in such a simple yet impactful way (chef’s kiss).")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer012"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Illustration of herbs.",
      "src": "image/page17.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer013"
    }
  }, [_c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Lemons ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }), _vm._v("Sprinkle lemon zest over roasted or sautéed vegetables, and stir lemon juice into everything from soups, dips, and sauces to dressings and stews. With its transformative sunshiny brightness, almost everything can benefit from a squeeze of lemon. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Seeds ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _vm._v(" Sometimes the crunch of flaky sea salt can be just the thing, and the same can be said for the textural pick-me-up of seeds. Yes, seeds! From dressings to side dishes and even the main event, showering seeds in every color of the rainbow over finished dishes adds this addicting micro-crunch that you really can’t get anywhere else. Black and toasted sesame seeds, Charleston’s beloved benne seeds, mustard seeds, fennel seeds, celery seeds, and even pumpkin and pomegranate seeds are all things I use on the regular. It sounds pretentious to say that I’m always looking to "), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("increase the textural interest")]), _vm._v(" in my dishes. But it’s accurate all the same. I’m just here living out my truth, one poppy seed at a time. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Spice ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _vm._v(" Sometimes the thing that’s keeping a dish from achieving greatness is a noticeable lack of spice. So many recipes are improved by just a hint of heat, whether from simple cracked black pepper, a sprinkling of pickled jalapeños, or a splash of tasty hot sauce. The "), _c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor104"
    }
  }, [_vm._v("Chicken Fricassee")]), _vm._v(" in this book, for example, is made all the better by a finishing drizzle of hot sauce, and the same goes for the "), _c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors3#_idTextAnchor043"
    }
  }, [_vm._v("Tuna Salad with Roasted Lemon, Crunchy Potatoes, and Green Beans")]), _vm._v(" and "), _c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors9#_idTextAnchor108"
    }
  }, [_vm._v("Jezebel Chicken")]), _vm._v(". The flavors in these dishes might be perfect for you, just as they are. But if not, try a dash of something spicy and see what that does for you. Hot sauce, pickled jalapeños, crushed red pepper, chipotle powder, and hot paprika are my A-team. ")])]), _vm._v(" "), _c('div', {
    staticClass: "_idGenObjectLayout-1"
  }, [_c('div', {
    staticClass: "Basic-Graphics-Frame",
    attrs: {
      "id": "_idContainer014"
    }
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "Illustration of a pepper.",
      "src": "image/page18.jpg"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "Basic-Text-Frame",
    attrs: {
      "id": "_idContainer015"
    }
  }, [_c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Stock concentrates ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }), _vm._v("I use vegetarian, chicken, and/or beef stock concentrates not to make stock itself but to add quick, deep flavor to my soups, stews, dressings, and sauces. A little goes a long way, which is a key trait in some of my favorite lighter cooking staples. You don’t need much to make your food sing. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Sweetness ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _vm._v(" I keep a few nice bottles and jars of honey and pure maple syrup close by at all times when I’m cooking, and I can’t tell you how often I reach for them, seeking a little burst of natural sweetness in this and that. The almost smoky-sweet flavor of good-quality maple syrup is amazing when drizzled over fall soups like my "), _c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors10#_idTextAnchor116"
    }
  }, [_vm._v("Two-Ingredient Squash and Caramelized Onion Soup")]), _vm._v(", and of course, it’s the champion of any breakfast table. Honey brings its special floral sweetness to any recipe, balancing out a spicy "), _c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors1#_idTextAnchor014"
    }
  }, [_vm._v("Scorned-Women Hot Sauce")]), _vm._v(" or politely sweetening "), _c('a', {
    attrs: {
      "href": "#/Southern_Lights_Interiors6#_idTextAnchor073"
    }
  }, [_vm._v("Grits and Honey Granola Bars")]), _vm._v(". ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Toasted Nuts")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _vm._v(" Just as tiny seeds are wonderful for adding texture to our dishes, so too are toasted nuts. But they also happen to bring a ton of flavor to anything lucky enough to be topped with them. Toasting nuts only takes a few minutes and the flavor difference is huge—it’s absolutely worth doing. All varieties are welcome here, as my kitchen is basically an equal opportunity employer when it comes to nuts. As a Virginia-raised girl, I have a special affection for peanuts, but pistachios, pecans, and walnuts are also interchangeably delicious. The almost browned butter-like flavor of toasted hazelnuts around the winter holidays is one of the very best things, I think. ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("To toast nuts: Put them on a rimmed baking sheet and roast in a 350")]), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("°")]), _c('em', {
    staticClass: "Emphasis _idGenCharOverride-1"
  }, [_vm._v("F oven until fragrant and golden brown, 6 to 10 minutes, depending on the nut. ")])]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Vinegars ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _vm._v(" Speaking of mediocrity, another tried-and-true cure so often can be found in the uplifting perkiness of vinegar. Like a fast and furious breath of fresh air, a simple splash of vinegar transforms so many things from “just okay” to “absolutely delicious.” Similar to the buoyancy offered by lemon juice, vinegar can take things even further with its bold assertiveness and strong acidic bite. My go-to vinegars are apple cider and balsamic, but there is a whole wide world of them out there, and experimentation and exploration are fully encouraged.  ")]), _vm._v(" "), _c('p', {
    staticClass: "Talky-Text-First",
    attrs: {
      "lang": "en-US"
    }
  }, [_c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("Yogurt ")]), _c('span', {
    staticClass: "Talky-Text-Inline-Heading _idGenCharOverride-3"
  }, [_vm._v("»")]), _vm._v(" I’ve made a very conspicuous switch to Greek yogurt in my kitchen, as a more nutritious substitute for butter, mayonnaise, sour cream, and cream cheese. It is not only a healthier option, but it’s also incredibly flavorful and works beautifully as a rich and creamy element in salad dressings, dips, drizzles, and even desserts. Many of the recipes in this book have yogurt going on somewhere, and they’re all the better for it.  ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcc9d854","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Southern_Lights_Interiors.vue
// module id = 57
// module chunks = 0